module.exports = __webpack_public_path__ + "img/community.3063f4fd.svg";